// extracted by mini-css-extract-plugin
module.exports = {"rivalCar":"RivalCar_rivalCar__0_hND","image":"RivalCar_image__6_XSc","name":"RivalCar_name__txDtF","mileage":"RivalCar_mileage__3bBgn","shimmer":"RivalCar_shimmer__kbohC"};